import { useBox } from "@react-three/cannon";
import { useRef } from "react";
import { Group } from "three";
import { Box, ObjectProps, useDragConstraint } from "../utils";

export default ({position, rotation}: ObjectProps) => {
  const [ref] = useBox(() => ({
    mass: 10,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    args: [4, 1, 2],
    type: 'Dynamic'
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  return (
    <group ref={ref} {...bind}>
      <Box args={[4, 1, 2]} position={[0, 0, 0]} color="#2a2a2a" />
    </group>
  );
};
